import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SCRIPT_RUNNER_SERVICE } from '../widgets/models/iscript-runner.service';
import { ScriptRunnerService } from './script-runner.service';

export function provideScriptsRunning(): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: SCRIPT_RUNNER_SERVICE, useClass: ScriptRunnerService }]);
}
